<template>
  <section class="container-fluid">
    <div class="row mb-4">
      <div class="col-6 mt-4">
        <h3><strong>Work Time Management</strong></h3>
      </div>
    </div>
    <div class="row">
      <div class="col-4 d-flex">
        <b-form-file
          v-model="formData.file"
          :state="Boolean(formData.file)"
          :placeholder="formData.placeholder"
          :drop-placeholder="formData.dropPlaceholder"
        />
        <button
          type="button"
          class="btn btn-primary button-update-file"
          @click.prevent="uploadFile"
          :disabled="isDataPageLoading"
        >
          Upload
        </button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'work-time-management',
  components: {},
  data () {
    return {
      formData: {
        file: null,
        placeholder: 'Choose a file or drop it here...',
        dropPlaceholder: 'Drop file here...'
      },
      isDataPageLoading: false
    }
  },
  methods: {
    uploadFile () {
      this._toggleDataPageLoading(async () => {
        await this.$api.workingTime.uploadFileReport(this.formData.file)
        this.$snotify.success(
          'File has been uploaded successfully',
          'Success',
          this.$store.state.snotify
        )
      })
    }
  }
}
</script>

<style scoped>
  .button-update-file{
    margin-left: 20px;
  }
</style>
